import { q as l } from "./index.CVakAlTX.js";
const f = (t) => Object.entries(t).map((e) => e.join("=")).join("|"), u = (t) => {
  if (!t.includes("filters."))
    return {};
  const e = {}, i = l.parse(t);
  return Object.keys(i).forEach((s) => {
    if (s.includes("filters.")) {
      const r = s.split(".")[1];
      r && (e[r] = i[s]);
    }
  }), e;
}, p = (t) => {
  const e = {};
  return t && t.split("|").forEach((c) => {
    const [s, r] = c.split("=");
    if (s && r) {
      const a = (r.includes(",") ? r.split(",") : [r]).map((o) => o.trim());
      e[s] = (e[s] || []).concat(a);
    }
  }), e;
}, j = (t) => l.stringify(t, { arrayFormat: "brackets", allowDots: !0 });
export {
  u as a,
  j as d,
  f,
  p as r
};
